<template>
 <div>
  <div class="Navbar" style="text-align:right">
   <b-navbar toggleable="custom" type="light" variant="info" style="z-index:1">
    <b-navbar-brand>
	<router-link class="headerLink" to="/">
          <img :src="logo" class="imgSize"/>
	</router-link>
    </b-navbar-brand>
    <b-navbar-toggle style='margin-right:8px' target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto">
       <b-nav-item class="margin_l"><b-link to="/events" class="navLink" :active="($route.path === '/events')" >Events</b-link></b-nav-item>
       <b-nav-item><b-link to="/programs" class="navLink" :active="($route.path === '/programs')">Programs</b-link></b-nav-item>
       <b-nav-item><b-link to="/whoweare" class="navLink" :active="($route.path === '/whoweare')">Who We Are</b-link></b-nav-item>
       <b-nav-item><b-link to="/give" class="navLink" :active="($route.path === '/give')">Give</b-link></b-nav-item>
       <b-nav-item><b-link to="/partners" class="navLink" :active="($route.path === '/partners')">Partners</b-link></b-nav-item>
       <b-nav-item><b-link to="/fatherhood" class="navLink" :active="($route.path === '/fatherhood')">Fatherhood Initiative</b-link></b-nav-item>
      </b-navbar-nav>
     </b-collapse>
    </b-navbar>
   </div>
   <router-view></router-view>
  </div>
</template>

<script>
export default {
   data: function () {
     return { logo : require('@/assets/logo.jpg') }
  },
  name: 'App',
  components: {}
}
</script>
<style>
body{font-family: "Open Sans", Roboto;}
@media screen and (max-height: 399px){
	.logo-img{ width: 180px;}
	.topContainer{
		top: 100px;
	}
}
@media screen and (min-height: 400px){
	.logo-img{ width: 210px;}
	.topContainer{
		top: 100px;
	}
}
@media (min-width: 1060px){
    .navbar-expand-custom {
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
    }
    .navbar-expand-custom .navbar-nav {
        flex-direction: row;
    }
    .navbar-expand-custom .navbar-nav .nav-link {
        padding-right: .1rem;
        padding-left: .1rem;
    }
    .navbar-expand-custom .navbar-collapse {
        display: flex !important;
        flex-basis: auto !important;
    }
    .navbar-expand-custom .navbar-toggler {
        display: none;
    }
}
#nav-collapse .navLink {
    margin-right: 10px;
}
.Navbar{
	position:fixed;
	z-index: 55;
	top:0;
	background-color: #fff;
	box-shadow: 0 2px #444;
	border: 1px solid #ccc;
	width: 100vw;
	font-size: 12px !important;
}
.nav-link {
    padding-top: 0.1em !important;
}
.navbar-light.bg-info{
	background-color: #fff !important;
}
.navbar-light .navbar-brand{
	padding: 0px;
}
.margin_l{
	margin-left: 40px;
}
.font_s{
	font-size: 0.95rem !important;
}
.font_b{font-weight: bold;}
.navbar{
	padding: 0.2rem 0.5rem !important;
}
a.navLink:link, a.navLink:visited, a.navLink:active, a.navLink:hover{
	color: #000;
	font-family: "Open Sans", "Lucida Grande";
	font-weight: normal;
	padding: 4px;
	text-decoration:none;
	border-bottom: 3px solid #fff;
	transition: all 0.5s ease;
  text-decoration: none;
}

a.headerLink:link, a.headerLink:visited, a.headerLink:active, a.headerLink:hover{
	color: #851e26;
	font-family: "Times New Roman", serif;
	font-weight: bold;
  font-size: 0.8em;
	padding: 4px;
	text-decoration:none;
	border-bottom: 3px solid #fff;
	transition: all 0.5s ease;
  text-decoration: none;
}

a.navLink:hover, a.navLink:active, a.numberLink:hover, a.numberLink:active {
	border-bottom: 3px solid green;
}
a.headerLink:hover, a.headerLink:active {
	color:#ed2d3c;
}
.imgSize {
   height: 87px;
   margin: 2px 2px;
}

</style>
